
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ProfilePostsDrG04yhoS6UquvJ2ilQL4QJmaAzD6WYOR1z2xzr7apsMeta } from "/builds/devhacker/lh-website-client/pages/ProfilePosts.vue?macro=true";
import { default as ProfileComments1f_45QivMcf_puLvU1JDWb_atMkDp9_PDmZrT7UwHxHpEMeta } from "/builds/devhacker/lh-website-client/pages/ProfileComments.vue?macro=true";
import { default as ProfileEdit_45fM9WbnC8JKW3l5_cP9EfTqbEI3YjxloFdYdM9vpyLUMeta } from "/builds/devhacker/lh-website-client/pages/ProfileEdit.vue?macro=true";
import { default as ProfileSettingsTIE6Dr_45hMdZIYgODwgTgeytDCBJmL7XzhGzVnGg1ZYQMeta } from "/builds/devhacker/lh-website-client/pages/ProfileSettings.vue?macro=true";
import { default as ProfileFavorites_0QsB7uTnu_JSNiM3ICjNso83J0h8MvhpaIjpTimC9kMeta } from "/builds/devhacker/lh-website-client/pages/ProfileFavorites.vue?macro=true";
import { default as ProfileFavoritesEditysP6EhMPG0g9_45qtqXq95RBXOEiy8VAxSjgDc0Ff7amUMeta } from "/builds/devhacker/lh-website-client/pages/ProfileFavoritesEdit.vue?macro=true";
import { default as ProfileNotificationsBJ56kuNPPdYjBiMl8M14HfMYLR83AHxWzfcXwmIXxy4Meta } from "/builds/devhacker/lh-website-client/pages/ProfileNotifications.vue?macro=true";
import { default as ProfileJI8RffuU21m1DB_Z6cKIRJeT_8rLFqRxNaGQl0bHG_45cMeta } from "/builds/devhacker/lh-website-client/pages/Profile.vue?macro=true";
import { default as Recipes9xcUD_OA1gmajmYF9NrdOnwkbaYkSw5vlU_wjLf32D0Meta } from "/builds/devhacker/lh-website-client/pages/Recipes.vue?macro=true";
import { default as TheRecipe_46ampgTjZpp3NmIzYPlWZle0hbmOaHvJYd8EFwl9hwH_45egHgMeta } from "/builds/devhacker/lh-website-client/pages/TheRecipe.amp.vue?macro=true";
import { default as TheRecipev_kvt0D_pO2BDkT1ECmMeywDtSTv0Az7saTY8MTR0ksMeta } from "/builds/devhacker/lh-website-client/pages/TheRecipe.vue?macro=true";
import { default as ArticleNavigatortOy7r6GD2C8iA_45eXs5f2c7eQrSoFpzsRzZeSbpN2zL4Meta } from "/builds/devhacker/lh-website-client/pages/ArticleNavigator.vue?macro=true";
import { default as ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta } from "/builds/devhacker/lh-website-client/pages/ArchivePage.vue?macro=true";
import { default as OldCoursesW9au4Oe6mcASBaWlaFOF7P6AvtJQLUF3JM6tt3j_4536IMeta } from "/builds/devhacker/lh-website-client/pages/OldCourses.vue?macro=true";
import { default as OldArchivesh78PaMlIGz_45LjxY7OUSP5ZgFplTaQTujCdlWlj4Yhb8Meta } from "/builds/devhacker/lh-website-client/pages/OldArchives.vue?macro=true";
import { default as SingleArticle_46amprgyqB8VQLGmfZJGsK0p_45TJK0K9j5A_45kZ2gA4T53QLtsMeta } from "/builds/devhacker/lh-website-client/pages/SingleArticle.amp.vue?macro=true";
import { default as YandbtmOTs_45SzTXsMionekYtrHgi6H44qiec8c5kpjnWj_lsa0Meta } from "/builds/devhacker/lh-website-client/pages/Yandbtm.vue?macro=true";
import { default as SearchArchivekJ90jCbKY8Z9nNm1WWKIs7EtONte_D0G_45WrOAGaHBKMMeta } from "/builds/devhacker/lh-website-client/pages/SearchArchive.vue?macro=true";
import { default as HealthHomedZCVTMS68X5vkVr7qg4twZxe4zz8wtvjB75YHiwKRbEMeta } from "/builds/devhacker/lh-website-client/pages/HealthHome.vue?macro=true";
import { default as HealthServiceszWK5p1_2F6jrWhCDtUz8ggYhx_45uSJnzz31hJ_45QkLAOUMeta } from "/builds/devhacker/lh-website-client/pages/HealthServices.vue?macro=true";
import { default as HealthNavigatorvMJUkCXPQOnPy8S0oIsA6bUKlX82ul_VsEeuKXJK2M4Meta } from "/builds/devhacker/lh-website-client/pages/HealthNavigator.vue?macro=true";
export default [
  {
    name: ProfileJI8RffuU21m1DB_Z6cKIRJeT_8rLFqRxNaGQl0bHG_45cMeta?.name,
    path: "/profile/user/:userId",
    meta: ProfileJI8RffuU21m1DB_Z6cKIRJeT_8rLFqRxNaGQl0bHG_45cMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/Profile.vue"),
    children: [
  {
    path: "",
    redirect: "comments"
  },
  {
    name: "profile-posts",
    path: "posts",
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfilePosts.vue")
  },
  {
    name: "profile-comments",
    path: "comments",
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileComments.vue")
  },
  {
    name: "profile-edit",
    path: "edit",
    meta: {"requiresAuth":true},
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileEdit.vue")
  },
  {
    name: "profile-settings",
    path: "settings",
    meta: {"requiresAuth":true},
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileSettings.vue")
  },
  {
    name: "profile-favorites",
    path: "favorites",
    meta: {"requiresAuth":true},
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileFavorites.vue")
  },
  {
    name: "profile-favorites-edit",
    path: "favorites-edit",
    meta: {"requiresAuth":true},
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileFavoritesEdit.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    meta: {"requiresAuth":true},
    component: () => import("/builds/devhacker/lh-website-client/pages/ProfileNotifications.vue")
  }
]
  },
  {
    name: "recipes-main-page",
    path: "/recipes/",
    meta: Recipes9xcUD_OA1gmajmYF9NrdOnwkbaYkSw5vlU_wjLf32D0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/Recipes.vue")
  },
  {
    name: "recipes-with-page",
    path: "/recipes/:slug*/page/:activePage",
    props: true,
    meta: Recipes9xcUD_OA1gmajmYF9NrdOnwkbaYkSw5vlU_wjLf32D0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/Recipes.vue")
  },
  {
    name: "recipes",
    path: "/recipes/:slug*",
    props: true,
    meta: Recipes9xcUD_OA1gmajmYF9NrdOnwkbaYkSw5vlU_wjLf32D0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/Recipes.vue")
  },
  {
    name: "TheRecipeAmp",
    path: "/recipe/:slug/amp",
    meta: TheRecipe_46ampgTjZpp3NmIzYPlWZle0hbmOaHvJYd8EFwl9hwH_45egHgMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/TheRecipe.amp.vue")
  },
  {
    name: "TheRecipe",
    path: "/recipe/:slug(.*)",
    meta: { ...(TheRecipev_kvt0D_pO2BDkT1ECmMeywDtSTv0Az7saTY8MTR0ksMeta || {}), ...{"middleware":"fetch-recipe-data"} },
    component: () => import("/builds/devhacker/lh-website-client/pages/TheRecipe.vue")
  },
  {
    name: "recipe-preview",
    path: "/preview/recipe/:id",
    meta: { ...(TheRecipev_kvt0D_pO2BDkT1ECmMeywDtSTv0Az7saTY8MTR0ksMeta || {}), ...{"middleware":"fetch-recipe-data"} },
    component: () => import("/builds/devhacker/lh-website-client/pages/TheRecipe.vue")
  },
  {
    name: "single-topics",
    path: "/topics/",
    component: () => import("/builds/devhacker/lh-website-client/pages/ArticleNavigator.vue")
  },
  {
    name: "topics-all",
    path: "/topics/:pathMatch(.*)",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "author-all",
    path: "/author/:pathMatch(.*)",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    alias: ["/health/author/:pathMatch(.*)"],
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "tag-all",
    path: "/tag/:pathMatch(.*)",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    alias: ["/health/tag/:pathMatch(.*)"],
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "list-all",
    path: "/list/",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    alias: ["/health/list/"],
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "stream-all",
    path: "/stream/:pathMatch(.*)",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    alias: ["/health/stream/:pathMatch(.*)"],
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    path: "/top/",
    name: "top-redirect",
    redirect: "/top/week/"
  },
  {
    name: "top-all",
    path: "/top/:pathMatch(week.*|month.*|year.*|all.*)?",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "index",
    path: "/",
    meta: ArchivePage7ltFu2ntFdRxRi19R1Vej6F_ryDWAyniX6f9poqtxb0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/ArchivePage.vue")
  },
  {
    name: "courses",
    path: "/kursy/:pathMatch(.*)",
    component: () => import("/builds/devhacker/lh-website-client/pages/OldCourses.vue")
  },
  {
    name: "archive-year",
    path: "/:year([0-9]{4})",
    alias: ["/health/:year([0-9]{4})"],
    component: () => import("/builds/devhacker/lh-website-client/pages/OldArchives.vue")
  },
  {
    name: "archive-month",
    path: "/:year([0-9]{4})/:month([0-9]{1,2})",
    alias: ["/health/:year([0-9]{4})/:month([0-9]{1,2})"],
    component: () => import("/builds/devhacker/lh-website-client/pages/OldArchives.vue")
  },
  {
    name: "archive-day",
    path: "/:year([0-9]{4})/:month([0-9]{1,2})/:day([0-9]{1,2})",
    alias: ["/health/:year([0-9]{4})/:month([0-9]{1,2})/:day([0-9]{1,2})"],
    component: () => import("/builds/devhacker/lh-website-client/pages/OldArchives.vue")
  },
  {
    name: "preview",
    path: "/preview/:articleId",
    component: () => import("/builds/devhacker/lh-website-client/pages/ArticleNavigator.vue")
  },
  {
    name: "single-amp",
    path: "/:slug*/amp",
    meta: SingleArticle_46amprgyqB8VQLGmfZJGsK0p_45TJK0K9j5A_45kZ2gA4T53QLtsMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/SingleArticle.amp.vue")
  },
  {
    name: "yandbtm",
    path: "/yandbtm",
    meta: YandbtmOTs_45SzTXsMionekYtrHgi6H44qiec8c5kpjnWj_lsa0Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/Yandbtm.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/devhacker/lh-website-client/pages/SearchArchive.vue")
  },
  {
    path: "/ext-search/",
    name: "ext-search",
    redirect: "search"
  },
  {
    name: "health-home",
    path: "/health/",
    meta: HealthHomedZCVTMS68X5vkVr7qg4twZxe4zz8wtvjB75YHiwKRbEMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/HealthHome.vue")
  },
  {
    name: "health-services",
    path: "/health/services",
    meta: HealthServiceszWK5p1_2F6jrWhCDtUz8ggYhx_45uSJnzz31hJ_45QkLAOUMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/HealthServices.vue")
  },
  {
    name: "health-article-amp-category",
    path: "/health/:category/:slug/amp",
    meta: SingleArticle_46amprgyqB8VQLGmfZJGsK0p_45TJK0K9j5A_45kZ2gA4T53QLtsMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/SingleArticle.amp.vue")
  },
  {
    name: "health-article-amp-categoryOrSlug",
    path: "/health/:categoryOrSlug/amp",
    meta: SingleArticle_46amprgyqB8VQLGmfZJGsK0p_45TJK0K9j5A_45kZ2gA4T53QLtsMeta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/SingleArticle.amp.vue")
  },
  {
    name: "health-article",
    path: "/health/:category/:slug",
    meta: HealthNavigatorvMJUkCXPQOnPy8S0oIsA6bUKlX82ul_VsEeuKXJK2M4Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/HealthNavigator.vue")
  },
  {
    name: "health-section",
    path: "/health/:categoryOrSlug",
    meta: HealthNavigatorvMJUkCXPQOnPy8S0oIsA6bUKlX82ul_VsEeuKXJK2M4Meta || {},
    component: () => import("/builds/devhacker/lh-website-client/pages/HealthNavigator.vue")
  },
  {
    name: "single",
    path: "/:pathMatch(.*)",
    component: () => import("/builds/devhacker/lh-website-client/pages/ArticleNavigator.vue")
  }
]